import { CustomCode } from '../custom-code';
export namespace Task {
    /** 提醒事项状态枚举 */
    export enum TaskRemindingStatus {
        /** 未读 */
        unread = 1,

        /** 已读 */
        read = 2,

        /** 全部 */
        all = 3,
    }

    /** 待办数量类型 */
    export enum TodoCountType {
        /** 我发起的 */
        MyInstance = 'myInstanceCount',

        /** 待办 */
        UnFinished = 'unFinishedCount',

        /** 待阅 */
        UnRead = 'unReadCount',

        /** 全部 */
        All = 'all',
    }

    /** 提醒事项摘要数据结构 */
    export interface IRemindingSummary {
        /** 提醒时间 */
        alertTime: string;

        /** 数据所属应用编码 */
        appCode: string;

        /** 业务数据编码 */
        bizObjectId: string;

        /** 提醒事项名称 */
        name: string;

        /** 数据所属表单编码 */
        schemaCode: string;

        /** 数据所属表单名称 */
        schemaName: string;

        /** 提醒摘要（提醒内容） */
        summary: string;

        /** 任务编码（提醒事项编码） */
        taskId: string;

        /** 提醒事项状态 */
        taskState: TaskRemindingStatus;
    }

    /** 待办数量 */
    export interface TodoCount {
        /** 我发起的数量 */
        [TodoCountType.MyInstance]: number;

        /** 待办数量 */
        [TodoCountType.UnFinished]: number;

        /** 待阅数量 */
        [TodoCountType.UnRead]: number;
    }

    /**
     * 视图按钮使用taskManager的任务场景
     */
    export enum TaskScene {
        Automation = 'Automation',
        BatchEdit = 'ScheduleCode_BatchUpdate',
    }
    /**
     * 视图按钮使用taskManager的任务类型
     */
    export enum TaskType {
        Sync = 'Sync', //同步
        Async = 'Async', //异步
    }

    export namespace Request {
        export interface IAddTask {
            schemaCode: string;
            actionCode: string;
            actionName: string;
            bizObjectIds: string[];
            bizData: unknown;
            appendOpFields: string[];
        }
        export interface IProcess {
            taskIds: string[];
        }
        export interface IGetTaskQueue {
            schemaCode: string;
        }
        export interface IGetEditableControl {
            schemaCode: string;
        }
    }
    export namespace Response {
        export interface IAddTask {
            successful: boolean;
            errorMessage: null | string;
            returnData: {
                taskId: string;
                logTime: string;
            };
        }
        export interface IProcess {
            successful: boolean;
            errorMessage: null | string;
            returnData: Record<string, progressItem>;
        }
        type progressItem = {
            total: number;
            success: number;
            failed: number;
            state: CustomCode.ACTION_TASK_STATE;
        };
        export interface IGetTaskQueue {
            successful: boolean;
            errorMessage: null | string;
            returnData: CustomCode.ITaskItem[];
        }
        type editableControlItem = {
            Visible: boolean;
            Editable: boolean;
            Required: boolean;
            Printable: boolean;
        };
        export interface IGetEditableControl {
            successful: boolean;
            errorMessage: null | string;
            returnData: Record<string, editableControlItem>;
        }
    }
}
